import { DEFAULT_LANGUAGE } from '../constants';

export function resolveTextValue(value: unknown, language = DEFAULT_LANGUAGE): string {
    if (typeof value === 'string') return value;
    if (!value || typeof value !== 'object') return '';
    const tv = value as Record<string, any>;
    if (!('format' in tv) || !('i18n' in tv)) return '';
    const i18n = tv['i18n'];
    if (!i18n || typeof i18n !== 'object') return '';
    if (language in i18n && i18n[language] != null) return String(i18n[language]);
    const fallback = Object.values(i18n).find(v => v != null);
    return fallback != null ? String(fallback) : '';
}

export function resolveTextValuesDeep<T>(value: T, language = DEFAULT_LANGUAGE): T {
    if (Array.isArray(value)) return value.map(item => resolveTextValuesDeep(item, language)) as T;
    if (value && typeof value === 'object' && 'format' in value && 'i18n' in value) return resolveTextValue(value, language) as T;
    if (value && typeof value === 'object') {
        const resolved: Record<string, any> = {};
        for (const [key, fieldValue] of Object.entries(value)) {
            resolved[key] = resolveTextValuesDeep(fieldValue, language);
        }
        return resolved as T;
    }
    return value;
}
